import { useQuery } from '@tanstack/react-query';
import { specialDateHoursApi } from '@/lib/api';
import { queryKeys } from '@/lib/query-client';

export function useGeelyCareWeekendDates(storeId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.specialDateHours(storeId || ''),
    queryFn: async () => {
      const response = await specialDateHoursApi.list({ storeId: storeId! });
      return response.data
        .filter(h => h.isGeelyCareWeekend && h.isActive && !h.isClosed)
        .map(h => h.date);
    },
    enabled: !!storeId,
  });
}
